export const KanzhongBackend = {
  LOGIN: '/v1/auth/login',
  GET_USER_SESSION: '/v1/auth/session',
  CREATE_USER: '/v1/user/create',
  UPDATE_USER: '/v1/user/update',
  DELETE_USER: '/v1/user/delete',
  GET_USER: '/v1/user/get',
  LIST_MANAGER: '/v1/user/manager',
  CREATE_USER_ROLE: '/v1/user/role/create',
  CREATE_PARTNER: '/v1/partner/create',
  UPDATE_PARTNER: '/v1/partner/update',
  GET_PARTNER: '/v1/partner/get',
  LIST_PARTNER: '/v1/partner/list',
  CREATE_CLIENT: '/v1/client/create',
  UPDATE_CLIENT: '/v1/client/update',
  GET_CLIENT: '/v1/client/get',
  LIST_CLIENT: '/v1/client/list',
  CREATE_MEMBER: '/v1/member/create',
  UPDATE_MEMBER: '/v1/member/update',
  DELETE_MEMBER: '/v1/member/delete',
  GET_MEMBER: '/v1/member/get',
  LIST_MEMBER: '/v1/member/list',
  CREATE_PROJECT: '/v1/project/create',
  UPDATE_PROJECT: '/v1/project/update',
  GET_PROJECT: '/v1/project/get',
  LIST_PROJECT: '/v1/project/list',
  LIST_ADMIN_NOTICE: '/v1/notice/admin/list',
  CREATE_ADMIN_NOTICE: '/v1/notice/admin/create',
  UPDATE_ADMIN_NOTICE: '/v1/notice/admin/update',
  DELETE_ADMIN_NOTICE: '/v1/notice/admin/delete',
  RESOLVE_ADMIN_NOTICE: '/v1/notice/admin/resolve',
  LIST_USER_NOTICE: '/v1/notice/list',
  DELETE_USER_NOTICE: '/v1/notice/delete',
  RESOLVE_USER_NOTICE: '/v1/notice/resolve',
  GET_MASTER_TYPE: '/v1/master/type',
  GET_TECH_STACK: '/v1/master/tech-stack',
  CREATE_NEXT_FINANCIAL_YEAR: '/v1/financial-year/create',
  LIST_FINANCIAL_YEAR: '/v1/financial-year',
  GET_FINANCIAL_YEAR: '/v1/financial-year',
  LIST_CONTRACT_REQUEST_CHECKLIST: '/v1/contract/request/checklist/get',
  CREATE_CONTRACT_REQUEST_CHECKLIST: '/v1/contract/request/checklist/create',
  UPDATE_CONTRACT_REQUEST_CHECKLIST: '/v1/contract/request/checklist/update',
  DELETE_CONTRACT_REQUEST_CHECKLIST: '/v1/contract/request/checklist/delete',
  REORDER_CONTRACT_REQUEST_CHECKLIST: '/v1/contract/request/checklist/reorder',
  GET_CONTRACT_TEMPLATE: '/v1/contract/template/get',
  CREATE_CONTRACT_TEMPLATE_GROUP: '/v1/contract/template/group/create',
  UPDATE_CONTRACT_TEMPLATE_GROUP: '/v1/contract/template/group/update',
  UPDATE_CONTRACT_TEMPLATE_GROUP_DISPLAY: '/v1/contract/template/group/display',
  CREATE_CONTRACT_TEMPLATE_ITEM: '/v1/contract/template/item/create',
  UPDATE_CONTRACT_TEMPLATE_ITEM: '/v1/contract/template/item/update',
  DELETE_CONTRACT_TEMPLATE_ITEM: '/v1/contract/template/item/delete',
  UPDATE_CONTRACT_TEMPLATE_ITEM_DISPLAY: '/v1/contract/template/item/display',
  GET_CONTRACT: '/v1/contract/get',
  LIST_CONTRACT: '/v1/contract/list',
  CREATE_CONTRACT_REQUEST: '/v1/contract/request/create',
  CHANGE_CONTRACT_REQUEST: '/v1/contract/request/change/create',
  TERMINATE_CONTRACT_REQUEST: '/v1/contract/request/terminate/create',
  UPDATE_CONTRACT_REQUEST: '/v1/contract/request/update',
  UPDATE_CONTRACT_REQUEST_STATUS: '/v1/contract/request/status',
  APPROVE_CONTRACT_REQUEST: '/v1/contract/request/approve',
  GET_CONTRACT_REQUEST: '/v1/contract/request/get',
  LIST_CONTRACT_REQUEST: '/v1/contract/request/list',
  CHECK_CONTRACT_REQUEST: '/v1/contract/request/check',
  CREATE_CONTRACT_COMMENT: '/v1/contract/request/comment/create',
  LIST_CONTRACT_COMMENT: '/v1/contract/request/comment/get',
  LIST_SEARCH_CONDITION: '/v1/search-condition',
  CREATE_SEARCH_CONDITION: '/v1/search-condition/create',
  DELETE_SEARCH_CONDITION: '/v1/search-condition/delete',
  SET_DEFAULT_SEARCH_CONDITION: '/v1/search-condition/set-default',
  UNSET_DEFAULT_SEARCH_CONDITION: '/v1/search-condition/unset-default',
  // --- User Profile（API8201-8204）---
  GET_USER_PROFILE: '/v1/user-profile', // API8201 + /{profileKey}?profileType=AUTO
  CREATE_USER_PROFILE: '/v1/user-profile/create', // API8202（MANUAL専用・将来用）
  DELETE_USER_PROFILE: '/v1/user-profile/delete', // API8203
  SAVE_USER_PROFILE: '/v1/user-profile/save', // API8204（AUTO upsert）
  CREATE_ASSESSMENT: '/v1/assessment/create',
  UPDATE_ASSESSMENT: '/v1/assessment/update',
  DELETE_ASSESSMENT: '/v1/assessment/delete',
  GET_ASSESSMENT: '/v1/assessment',
  LIST_ASSESSMENT: '/v1/assessment/list',
  LIST_SECURITY_CHECK_ADMIN: '/v1/security-check/admin/list',
  GET_SECURITY_CHECK_DETAIL: '/v1/security-check/admin/detail',
  START_SECURITY_CHECK: '/v1/security-check/admin/start',
  REMIND_SECURITY_CHECK: '/v1/security-check/admin/remind',
  LIST_SECURITY_CHECK_RESULT: '/v1/security-check/list',
  GET_SECURITY_CHECK_RESULT: '/v1/security-check',
  EXECUTE_SECURITY_CHECK: '/v1/security-check/execute',
  GET_CONTRACT_PASTE_DEFINITION: '/v1/contract/template/paste/get',
  CREATE_CONTRACT_PASTE_DEFINITION: '/v1/contract/template/paste/create',
  UPDATE_CONTRACT_PASTE_DEFINITION: '/v1/contract/template/paste/update',
  DELETE_CONTRACT_PASTE_DEFINITION: '/v1/contract/template/paste/delete',
  CREATE_TRACE: '/v1/trace',
  // --- Training / CodeExecute ---
  EXECUTE_CODE: '/v1/training/code-execute',
  LIST_CODE_EXECUTION_RESULT: '/v1/training/code-execute/result', // + /{fileId}/list
  GET_CODE_EXECUTION_RESULT: '/v1/training/code-execute/result', // + /{fileId}/{seq}
  DELETE_CODE_EXECUTION_RESULT: '/v1/training/code-execute/result/delete',
  // --- Training / WorkSpace ---
  GET_WORKSPACE: '/v1/training/workspace',
  CREATE_WORKSPACE_FOLDER: '/v1/training/workspace/folder/create',
  CREATE_WORKSPACE_FILE: '/v1/training/workspace/file/create',
  RENAME_WORKSPACE_NODE: '/v1/training/workspace/rename',
  DELETE_WORKSPACE_NODE: '/v1/training/workspace/delete',
  GET_WORKSPACE_FILE: '/v1/training/workspace/file', // + /{fileId}
  SAVE_WORKSPACE_FILE: '/v1/training/workspace/file/save',
  REVERT_WORKSPACE_FILE: '/v1/training/workspace/file/revert',
  GET_ADMIN_WORKSPACE: '/v1/training/workspace/admin/get',
  MOVE_WORKSPACE_NODE: '/v1/training/workspace/move', // API6112
  LIST_FILE_EXTENSION: '/v1/training/file-extension',
  // --- Article（記事）---
  // 未ログイン可（/v1/public/ 配下）
  LIST_ARTICLE: '/v1/public/article/list', // API6201
  GET_ARTICLE: '/v1/public/article', // API6202 + /{articleId}
  GET_PUBLIC_ARTICLE_FILE: '/v1/public/article/file', // API6111 + /{fileId}
  LIST_LABEL: '/v1/public/article/label/list', // API6207
  // 認証必須
  CREATE_ARTICLE: '/v1/article/create', // API6203
  UPDATE_ARTICLE: '/v1/article/update', // API6204
  DELETE_ARTICLE: '/v1/article/delete', // API6205
  CHANGE_ARTICLE_VISIBILITY: '/v1/article/visibility', // API6206
  CREATE_LABEL: '/v1/article/label/create', // API6208
  UPDATE_LABEL: '/v1/article/label/update', // API6209
  DELETE_LABEL: '/v1/article/label/delete', // API6210
  REFLECT_ARTICLE: '/v1/article/reflect', // API6211（記事反映・保存/反映分離）
  // --- Training / 研修管理（DEVELOPER のみ）---
  CREATE_TRAINING_ASSIGNMENT: '/v1/training/admin/assignment/create', // API6301
  UPDATE_TRAINING_ASSIGNMENT: '/v1/training/admin/assignment/update', // API6302
  HIDDEN_TRAINING_ASSIGNMENT: '/v1/training/admin/assignment/hidden', // API6303
  GET_TRAINING_ASSIGNMENT: '/v1/training/admin/assignment/get', // API6304
  LIST_TRAINING_ASSIGNMENT: '/v1/training/admin/assignment/list', // API6305
  CREATE_TRAINING_QUESTION: '/v1/training/admin/question/create', // API6311
  UPDATE_TRAINING_QUESTION: '/v1/training/admin/question/update', // API6312
  HIDDEN_TRAINING_QUESTION: '/v1/training/admin/question/hidden', // API6313
  GET_TRAINING_QUESTION_ADMIN: '/v1/training/admin/question/get', // API6314
  LIST_TRAINING_QUESTION_ADMIN: '/v1/training/admin/question/list', // API6315
  SYNC_TRAINING_QUESTION: '/v1/training/admin/question/sync', // API6316（設問反映）
  ADD_TRAINING_ASSIGNMENT_QUESTION: '/v1/training/admin/assignment/question/add', // API6321
  REMOVE_TRAINING_ASSIGNMENT_QUESTION: '/v1/training/admin/assignment/question/remove', // API6322
  ASSIGN_TRAINING_ASSIGNMENT: '/v1/training/admin/assignment/assign', // API6331
  LIST_TRAINING_PROGRESS: '/v1/training/admin/progress/list', // API6341（進捗サマリ）
  GET_TRAINING_PROGRESS_DETAIL: '/v1/training/admin/progress/detail', // API6342（進捗詳細）
  // --- Training / 研修受講（全ユーザー・認証のみ）---
  LIST_TRAINING_LEARN_ASSIGNMENT: '/v1/training/assignment/list', // API6351（割当課題一覧）
  LIST_TRAINING_LEARN_QUESTIONS: '/v1/training/assignment/questions', // API6352（課題設問一覧）
  GET_TRAINING_LEARN_QUESTION: '/v1/training/question/get', // API6353（設問取得）
  VERIFY_TRAINING_ANSWER: '/v1/training/question/verify', // API6354（解答検証）
  // --- Ticket / 種別 (API7001-7006) ---
  LIST_TICKET_TYPE: '/v1/ticket/type/list', // API7001
  GET_TICKET_TYPE: '/v1/ticket/type/get', // API7002
  CREATE_TICKET_TYPE: '/v1/ticket/type/create', // API7003
  UPDATE_TICKET_TYPE: '/v1/ticket/type/update', // API7004
  DELETE_TICKET_TYPE: '/v1/ticket/type/delete', // API7005
  ACTIVE_TICKET_TYPE: '/v1/ticket/type/active', // API7006
  // --- Ticket / フォームテンプレート (API7011-7024) ---
  CREATE_TICKET_FORM_GROUP: '/v1/ticket/type/form/group/create', // API7011
  UPDATE_TICKET_FORM_GROUP: '/v1/ticket/type/form/group/update', // API7012
  UPDATE_TICKET_FORM_GROUP_DISPLAY: '/v1/ticket/type/form/group/display', // API7014
  CREATE_TICKET_FORM_ITEM: '/v1/ticket/type/form/item/create', // API7021
  UPDATE_TICKET_FORM_ITEM: '/v1/ticket/type/form/item/update', // API7022
  DELETE_TICKET_FORM_ITEM: '/v1/ticket/type/form/item/delete', // API7023
  UPDATE_TICKET_FORM_ITEM_DISPLAY: '/v1/ticket/type/form/item/display', // API7024
  // --- Ticket / 本体 (API7101-7122) ---
  CREATE_TASK_TICKET: '/v1/ticket/task/create', // API7101
  UPDATE_TASK_TICKET: '/v1/ticket/task/update', // API7102
  GET_TICKET: '/v1/ticket/get', // API7104
  LIST_TICKET: '/v1/ticket/list', // API7105
  CREATE_APPROVAL_TICKET: '/v1/ticket/approval/create', // API7106
  UPDATE_APPROVAL_TICKET: '/v1/ticket/approval/update', // API7107
  UPDATE_TASK_STATUS: '/v1/ticket/task/status', // API7111
  UPDATE_TASK_ASSIGNEE: '/v1/ticket/task/assignee', // API7112
  UPDATE_TASK_SCHEDULE: '/v1/ticket/task/schedule', // API7113
  UPDATE_APPROVAL_STATUS: '/v1/ticket/approval/status', // API7121
  APPROVE_TICKET: '/v1/ticket/approval/approve', // API7122
  // --- Ticket / コメント・ウォッチ (API7131-7142) ---
  CREATE_TICKET_COMMENT: '/v1/ticket/comment/create', // API7131
  LIST_TICKET_COMMENT: '/v1/ticket/comment/get', // API7132
  ADD_TICKET_WATCH: '/v1/ticket/watch/add', // API7141
  REMOVE_TICKET_WATCH: '/v1/ticket/watch/remove', // API7142
  // --- Expense / 品目ラベル (API4111-4114) ---
  LIST_EXPENSE_LABEL: '/v1/expense/label/list', // API4111
  CREATE_EXPENSE_LABEL: '/v1/expense/label/create', // API4112
  UPDATE_EXPENSE_LABEL: '/v1/expense/label/update', // API4113
  DELETE_EXPENSE_LABEL: '/v1/expense/label/delete', // API4114
  // --- Expense / 店舗 (API4121-4124) ---
  LIST_EXPENSE_STORE: '/v1/expense/store/list', // API4121
  CREATE_EXPENSE_STORE: '/v1/expense/store/create', // API4122
  UPDATE_EXPENSE_STORE: '/v1/expense/store/update', // API4123
  DELETE_EXPENSE_STORE: '/v1/expense/store/delete', // API4124
  // --- Expense / 経費 (API4131-4135) ---
  CREATE_EXPENSE: '/v1/expense/create', // API4131
  UPDATE_EXPENSE: '/v1/expense/update', // API4132
  DELETE_EXPENSE: '/v1/expense/delete', // API4133
  GET_EXPENSE: '/v1/expense', // API4134 + /{expenseId}
  LIST_EXPENSE: '/v1/expense/list', // API4135
  // --- Expense / 候補・集計 (API4141-4142) ---
  SEARCH_EXPENSE_SUGGESTION: '/v1/expense/suggestion', // API4141 ?keyword=&matchType=
  AGGREGATE_EXPENSE: '/v1/expense/aggregate', // API4142
} as const;
